<template>
<div
  class="Lightbox"
  id="InforBox">
  <div
    @click="close"
    class="LightboxOverlay"></div>
  <div class="LightboxWrap">
    <div
      class="close"
      @click="close"></div>
    <div class="Content">
      <div class="Information">{{message}}</div>
      <div
        v-if="isConfirm"
        class="InformationBtn">
        <a href="#" title="留在原頁">留在原頁</a>
        <a href="#" title="確認離開">確認離開</a>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: "alert",
  props: {
    message: {
      type: String,
      default: ''
    },
    isConfirm: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    close() {
      this.$emit('closeAlertTips')
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../../style/icon.scss";

.Information {
  text-align: center;
  line-height: 82px;
}

.LightboxWrap {
  position: relative;

  .close {
    width: 45px;
    height: 45px;
    position: absolute;
    top: 0;
    right: 0;
  }
}

.InformationBtn {
  text-align: right;

  a {
    color: #558fff;
    margin-left: 5%;
  }
}

#InforBox {
  .LightboxWrap {
    min-height: 138px;
    max-width: 298px;
  }

  .Information {
    min-height: 82px;
  }

  .Content {
    padding: 5%;
  }
}
</style>
